import { COMMON_NAMESPACE } from '@porsche-code/kado-i18n';

const DEFAULT_NAMESPACE = 'dashboard';
const NAMESPACES = [DEFAULT_NAMESPACE, COMMON_NAMESPACE] as const;

export { COMMON_NAMESPACE, DEFAULT_NAMESPACE, NAMESPACES };
